import Graphic from "@arcgis/core/Graphic";
import esriRequest from "@arcgis/core/request";
//import esri = __esri;
import {
  Extent,
  Point,
  Polyline,
  Polygon,
  Multipoint,
  Geometry,
  SpatialReference,
} from "@arcgis/core/geometry";
import { project } from "@arcgis/core/rest/geometryService";
import ProjectParameters from "@arcgis/core/rest/support/ProjectParameters";
import GeometryService from "@arcgis/core/tasks/GeometryService";
import { whenOnce } from "@arcgis/core/core/watchUtils";
import ActionButton from "@arcgis/core/support/actions/ActionButton";
import {
  operationalLayerName,
  operationalLayerUrl,
  operationalLayers,
  assessorInfo,
  operationalMapUrl,
  tracing,
  IsDisplayDateUTC,
  planAreaLayerName,
  planAreafields,
  GeometryServiceURL,
} from "../appConfig";
import { traceGraphicLayer } from "../data/layers";
const geomSer = new GeometryService({ url: GeometryServiceURL });
const arrayOutfields = planAreafields;
export const getLayerIdFromService = (view: MapView, layernames: string[]) => {
  const layerIds: any[] = [];
  view.map.layers.map((item: any) => {
    if (
      item.operationalLayerType === "ArcGISMapServiceLayer" &&
      item.id === "operationalMap"
    ) {
      item.allSublayers.map((subLayerItem: any) => {
        if (
          layernames.includes(subLayerItem.title) &&
          subLayerItem.visible === true && (subLayerItem.parent && subLayerItem.parent.visible === true)
        ) {
          layerIds.push(subLayerItem.id);
        }
      });
    }
  });
  return layerIds;
};
export const getLayerSubLayerFromService = (view: MapView, layernames: string[]) => {
  const sublayers: any[] = [];
  view.map.layers.map((item: any) => {
    if (
      item.operationalLayerType === "ArcGISMapServiceLayer" &&
      item.id === "operationalMap"
    ) {
      item.allSublayers.forEach((subLayerItem: any) => {
        if (
          layernames.includes(subLayerItem.title) &&
          subLayerItem.visible === true && (subLayerItem.parent && subLayerItem.parent.visible === true)
        ) {
          sublayers.push(subLayerItem);
        }
      });
    }
  });
  return sublayers;
};
export const handleIdentifyResults = async (response: any) => {
  const results = response.results;
  const retItems: esri.Graphic[] = [];
  const relatedPlanItems: any[] = [];

  results.forEach(async (result: any) => {
    const featureItem = result.feature as esri.Graphic;
    const itemLayerName = result.layerName;
    if (planAreaLayerName === itemLayerName) {
      relatedPlanItems.push(featureItem); //store the plan items here
    }
  });

  await Promise.all(
    results.map(async (result: any) => {
      const featureItem = result.feature as esri.Graphic;
      const itemLayerName = result.layerName;
      if (planAreaLayerName === itemLayerName) {
        relatedPlanItems.push(featureItem); //store the plan items here
      } else {
        featureItem.attributes.LayerName = itemLayerName;
        featureItem.attributes.Geometry = result.feature.geometry.clone();
        featureItem.attributes.GeometryType = result.feature.geometry.type;
        featureItem.attributes.IsSelected = false;
        let indoWindowString = "";
        let filteredOpLayer = operationalLayers.filter(
          (opLayer: any, i: number) => {
            return opLayer.Key === itemLayerName;
          }
        );
        if (itemLayerName === operationalLayerName) {
          const results = (await getRelatedAssessorData([
            featureItem,
          ])) as esri.Graphic[];
          results.forEach((item: esri.Graphic) => {
            item.attributes.LayerName = operationalLayerName;
            item.attributes.Geometry = result.feature.geometry.clone();
            item.attributes.GeometryType = result.feature.geometry.type;
            item.attributes.IsSelected = false;
            item.LayerName = itemLayerName;
            item.planAttributes = [];
            //adding plan field values to attributes
            let hasPlan = filteredOpLayer[0].HasPlan;
            item.HasPlan = hasPlan;
            if (hasPlan) {
              relatedPlanItems.forEach((planItem: esri.Graphic) => {
                const filtered = Object.keys(planItem.attributes)
                  .filter((key) => arrayOutfields.includes(key))
                  .reduce((obj, key) => {
                    return {
                      ...obj,
                      [key]: planItem.attributes[key],
                    };
                  }, {});

                item.planAttributes.push(filtered);
              });
            }
            //adding GIS field values to assess
            const gisFields = filteredOpLayer[0].GISFieldsToBeAdded;
            gisFields.forEach((element: string) => {
              if (element !== filteredOpLayer[0].AssessLink)
                item.attributes[element] = result.feature.attributes[element];
            });
            retItems.push(item);
          });
        } else {
          if (filteredOpLayer.length !== 0) {
            indoWindowString =
              "<b>" +
              filteredOpLayer[0].InfoWindowFields[0].DisplayText +
              "</b>: " +
              featureItem.attributes[
                filteredOpLayer[0].InfoWindowFields[0].FieldName
              ];

            featureItem.popupTemplate = featureItem.getEffectivePopupTemplate();
            featureItem.popupTemplate = {
              // autocasts as new PopupTemplate()
              title: "Layer: " + featureItem.attributes.LayerName,
              content:
                `
            <span class='mugis-popup-content'>
            <span>` +
                indoWindowString +
                `</span>
            </span>
            `,
              actions: [
                {
                  title: "",
                  id: "details",
                  className: "esri-icon-documentation",
                },
                /*  {
                  title: "See GIS details",
                  id: "gisdetails",
                  className: "esri-icon-maps"
                } */
              ] as ActionButton[],
            };
            featureItem.LayerName = itemLayerName;
            featureItem.planAttributes = [];
            //adding plan field values to attributes
            let hasPlan = filteredOpLayer[0].HasPlan;
            featureItem.HasPlan = hasPlan;
            if (hasPlan) {
              relatedPlanItems.forEach((planItem: esri.Graphic) => {
                const filtered = Object.keys(planItem.attributes)
                  .filter((key) => arrayOutfields.includes(key))
                  .reduce((obj, key) => {
                    return {
                      ...obj,
                      [key]: planItem.attributes[key],
                    };
                  }, {});

                featureItem.planAttributes.push(filtered);
              });
            }
            retItems.push(featureItem);
          }
        }
      }
    })
  );

  retItems.sort(function(a, b) {
    let aindex = operationalLayers.findIndex((opl) => opl.Key === a.LayerName);
    let bindex = operationalLayers.findIndex((opl) => opl.Key === b.LayerName);
    return aindex - bindex;
  });
  return retItems;
};

export const getFormattedValue = (item: any, field: any) => {
  switch (field.DataType) {
    case "currency":
      try {
        return Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(item[field.FieldName]);
      } catch {
        return item[field.FieldName] !== undefined
          ? item[field.FieldName]
          : item[field.AliasName];
      }
      break;
    case "date":
      try {
        let value = item[field.FieldName];
        if (value === undefined || value === null) {
          return "N/A";
        }
        const fullFormatter = Intl.DateTimeFormat("en-US", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
        if (IsDisplayDateUTC) {
          // functionality to fix dates
          let oneDay = 24 * 60 * 60 * 1000;
          let val = value.getTime === "function" ? value.getTime() : value;
          // assumption: we want to shift datetimes where the time is midnight UTC (down to the millisecond);
          if (val % oneDay === 0) {
            // if the date has a time of midnight UTC, we shift it by the timezone offset
            let dateShift = new Date(val).getTimezoneOffset() * 60 * 1000;
            val = val + dateShift;
          }
          return fullFormatter.format(val);
        } else {
          return fullFormatter.format(value);
        }
      } catch {
        return item[field.FieldName] !== undefined
          ? item[field.FieldName]
          : item[field.AliasName];
      }
      break;
    default:
      return item[field.FieldName] !== undefined
        ? item[field.FieldName]
        : item[field.AliasName];
      break;
  }
};

export const getFormattedLocationValue = (item: any, field: any) => {
  //this is with multiple fields
  try {
    let locationValue = field.FieldNames.map((fieldname: string) => {
      return item[fieldname];
    });
    return locationValue.join(",") + ", " + assessorInfo.LocationCityState;
  } catch (err) {
    console.log("Error in getting location address" + err.message);
    return "";
  }
};

export const getRelatedAssessorData = async (items: Graphic[]) => {
  if (items == null || !items.length) return;
  let filteredOpLayer = operationalLayers.filter((opLayer: any, i: number) => {
    return opLayer.Key === operationalLayerName;
  });
  let OIDArr = items.map(
    (item) => item.attributes[filteredOpLayer[0].ObjectIDField] as number
  );

  const relatedFeatureSetByObjectId = await esriRequest(
    operationalLayerUrl + "/queryRelatedRecords",
    {
      query: {
        f: "json",
        relationshipId: filteredOpLayer[0].AssessRelationShipId,
        objectIds: OIDArr.join(","), //pagination not supported
        outFields: "*",
        returnGeometry: "false",
      },
      responseType: "json",
    }
  );

  if (!relatedFeatureSetByObjectId) {
    return;
  }

  var relatedObjsTranslated: Graphic[] = [];
  relatedFeatureSetByObjectId.data.relatedRecordGroups.forEach(
    ({ objectId }: { objectId: number }, i: number) => {
      // get the attributes of the FeatureSet
      const relatedFeatureSet =
        relatedFeatureSetByObjectId.data.relatedRecordGroups[i];
      relatedFeatureSet.relatedRecords.forEach((feature: esri.Graphic) => {
        items.forEach((item: esri.Graphic) => {
          if (
            item.attributes[filteredOpLayer[0].AssessLink] ===
            feature.attributes[assessorInfo.GIS_ID]
          ) {
            let tempItem = item.clone();
            tempItem.attributes = feature.attributes;

            let indoWindowString =
              "<b>" +
              filteredOpLayer[0].SingleUniqueField.AliasName +
              ": </b>" +
              feature.attributes[
                filteredOpLayer[0].SingleUniqueField.FieldName
              ];
            tempItem.popupTemplate = {
              // autocasts as new PopupTemplate()
              title: "Layer: " + operationalLayerName,
              content:
                `
            <span class="mugis-popup-content">
            <span>` +
                indoWindowString +
                `</span>
            </span>
            `,
              actions: [
                {
                  title: "",
                  id: "details",
                  className: "esri-icon-documentation",
                },
                /*  {
                  title: "See GIS details",
                  id: "gisdetails",
                  className: "esri-icon-maps"
                } */
              ] as ActionButton[],
            };
            relatedObjsTranslated.push(tempItem);
          }
        }); //console.log(items);
      });
    }
  );

  return relatedObjsTranslated;
};

export const clearMapGraphics = (gl: GraphicsLayer) => {
  if (gl !== undefined && gl !== null) {
    gl.removeAll();
  }
};
export const turnLayersVisible = async (
  view: MapView,
  layerNames: string[]
) => {
  if (!view) {
    return;
  }
  if (!view.ready) {
    await whenOnce(view, "ready");
  }

  const mapServiceStrArr = operationalMapUrl.split("/");
  view.map.allLayers.forEach((item: any) => {
    if (
      item.title ===
      mapServiceStrArr[mapServiceStrArr.length - 2].split("_").join(" ")
    ) {
      item.allSublayers.forEach((item: any) => {
        if (layerNames.includes(item.title)) {
          item.visible = true;
          item.parent.visible = true;
          if (item.visible && item.sublayers !== null) {
            item.sublayers.items.forEach((subLayerItem: any) => {
              subLayerItem.visible = true; //all ayers turned on if grp layer is on
            });
          }
        }
      });
    }
  });
};
export const zoomToFeatures = async (view: MapView, features: any[]) => {
  if (!view) {
    return;
  }
  if (!view.ready) {
    await whenOnce(view, "ready");
  }
  let zoomExtent = new Extent({
    xmin: 0.0,
    ymin: 0.0,
    xmax: 0.0,
    ymax: 0.0,
    spatialReference: {
      wkid: view.spatialReference.wkid,
    },
  });
  let tempMultipointArr: any[] = []; //new Multipoint({spatialReference: view.spatialReference});
  let itemGraphic: Graphic;
  if (features.length === 1 && features[0].GeometryType === "point") {
    if (view && view.ready) {
      const geomSer = new GeometryService({ url: GeometryServiceURL });
      const params = new ProjectParameters({
        geometries: [
          new Point({
            x: features[0].Geometry.x,
            y: features[0].Geometry.y,
            spatialReference: features[0].Geometry.spatialReference,
          }),
        ],
        outSpatialReference: view.spatialReference,
      });
      geomSer.project(params).then((geometries) => {
        view.goTo({ target: geometries, scale: 600 });
      });
    }
  } else {
    features.forEach(async (feature) => {
      switch (feature.GeometryType) {
        case "point":
          tempMultipointArr.push(
            new Point({
              x: feature.Geometry.x,
              y: feature.Geometry.y,
              spatialReference: feature.Geometry.spatialReference,
            })
          );
          itemGraphic = new Graphic({
            attributes: feature,
            geometry: new Point({
              x: feature.Geometry.x,
              y: feature.Geometry.y,
              spatialReference: feature.Geometry.spatialReference,
            }),
          });
          //displayedItemsGraphics.push(itemGraphic);
          break;
        case "polyline":
          itemGraphic = new Graphic({
            attributes: feature,
            geometry: new Polyline({
              paths: (feature.Geometry as any).paths,
              spatialReference: feature.Geometry.spatialReference,
            }),
          });
          //displayedItemsGraphics.push(itemGraphic);
          break;
        case "polygon":
          itemGraphic = new Graphic({
            attributes: feature,
            geometry: new Polygon({
              rings: (feature.Geometry as any).rings,
              spatialReference: feature.Geometry.spatialReference,
            }),
          });
          //displayedItemsGraphics.push(itemGraphic);
          break;
      }

      if (itemGraphic.geometry.type === "point") {
        //handle points separately
        //do nothing now
      } else {
        const params = new ProjectParameters({
          geometries: [itemGraphic.geometry],
          outSpatialReference: view.spatialReference,
        });
        await geomSer.project(params).then((geometries) => {
          geometries.forEach((geom) => {
            if (zoomExtent.xmax === 0 && zoomExtent.ymin === 0) {
              //it is empty
              zoomExtent = geom.extent.clone();
            } else {
              zoomExtent.union(geom.extent.clone());
            }
          });
          if (view && view.ready) {
            const mapZoom = zoomExtent.clone();
            if (
              mapZoom.extent !== null &&
              mapZoom.xmax !== 0 &&
              mapZoom.ymin !== 0
            ) {
              view.goTo(mapZoom.extent.expand(2.0));
            }
          }
        });
      }
    });
    if (tempMultipointArr.length > 0) {
      let tempMultipoint = new Multipoint({
        spatialReference: view.spatialReference,
      });
      const params = new ProjectParameters({
        geometries: tempMultipointArr,
        outSpatialReference: view.spatialReference,
      });
      await project(GeometryServiceURL, params).then((geometries) => {
        geometries.forEach((geom) => {
          tempMultipoint.addPoint(new Point(geom));
        });
        if (zoomExtent.xmax === 0 && zoomExtent.ymin === 0) {
          //it is empty
          zoomExtent = tempMultipoint.extent.clone();
        } else {
          zoomExtent.union(tempMultipoint.extent.clone());
        }
        if (view && view.ready) {
          const mapZoom = zoomExtent.clone();
          if (
            mapZoom.extent !== null &&
            mapZoom.xmax !== 0 &&
            mapZoom.ymin !== 0
          ) {
            view.goTo(mapZoom.extent.expand(2.0));
          }
        }
      });
    }
  }
};
//const querySearchItems: (item: any) => Promise<esri.Graphic[]> = async (
export const getTraceResults: (
  view: MapView,
  traceStartPt: Point,
  traceType: string,
  traceGraphicLayer: GraphicsLayer
) => Promise<void | Graphic[]> = async (view, traceStartPt, traceType) => {
  let traceResults: Graphic[] = [];
  if (traceType === "VALVEISOLATIONTRACE") {
    const controller = new AbortController();
    const signal = controller.signal;
    let loadImg = document.getElementById("mapLoaderImg");
    loadImg.classList.add("visible");

    return esriRequest(tracing.traceURL + "/ValveIsoTraceOperation", {
      query: {
        f: "json",
        location: JSON.stringify(traceStartPt), //  dojo.toJson(traceStartPt.toJson()),
        traceType: traceType,
        NetworkName: tracing.traceValveIso.networkName, //this.traceNetworkUpDown,
        ValveLayerName: tracing.traceValveIso.valveFeatureClass,
        PressureSourceLayerName:
          tracing.traceValveIso.pressureSourceFeatureClass,
        spatialReference: JSON.stringify(view.spatialReference),
      },
      responseType: "json",
      timeout: 60000,
      signal: signal,
    })
      .then((results) => {
        if (results.data && results.data.results.length > 0) {
          results.data.results[0].junctions.forEach((tracedJunctions: any) => {
            tracedJunctions.features.forEach((junc: any) => {
              /* junc.LayerName = tracedJunctions.LayerName;
                junc.geometry = new Point({
                  x: junc.geometry.x,
                  y: junc.geometry.y,
                  spatialReference: view.spatialReference,
                }); */
              traceResults.push(
                new Graphic({
                  geometry: new Point({
                    x: junc.geometry.x,
                    y: junc.geometry.y,
                    spatialReference: new SpatialReference({
                      wkid: tracedJunctions.spatialReference.wkid,
                    }),
                  }),
                  attributes: junc.attributes,
                  /* symbol: {
                    type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
                    style: "circle",
                    color: "blue",
                    size: "20px",  // pixels
                    outline: {  // autocasts as new SimpleLineSymbol()
                      color: [255, 255, 0, 0.7],
                      width: 12
                    }
                  }, */
                  LayerName: tracedJunctions.LayerName,
                })
              );
            });
          });

          results.data.results[0].edges.forEach((tracedEdges: any) => {
            tracedEdges.features.forEach((edge: any) => {
              /* edge.LayerName = tracedEdges.LayerName;
                edge.geometry = new Polyline({
                  paths: edge.geometry.paths,
                  spatialReference: view.spatialReference,
                }); */
              traceResults.push(
                new Graphic({
                  geometry: new Polyline({
                    paths: edge.geometry.paths,
                    spatialReference: new SpatialReference({
                      wkid: tracedEdges.spatialReference.wkid,
                    }),
                  }),
                  attributes: edge.attributes,
                  /* symbol: {
                    type: "simple-line",  // autocasts as new SimpleLineSymbol()
                    color: [0, 255, 255, 0.9],
                    width: "12px",
                    style: "solid",
                    join: "round",
                    miterLimit: "20px"
                  }, */
                  LayerName: tracedEdges.LayerName,
                })
              );
            });
          });
          //displayTraceGraphics(view, traceStartPt, results.data); //this needs to be changed later to pass on featureSet
          let loadImg = document.getElementById("mapLoaderImg");
          loadImg.classList.remove("visible");
          loadImg.classList.add("hidden");
          return traceResults;
        } else {
          return [];
        }

        //return traceResults;
      })
      .catch((err) => {
        let loadImg = document.getElementById("mapLoaderImg");
        loadImg.classList.remove("visible");
        loadImg.classList.add("hidden");
        if (err.name === "AbortError") {
          console.log("Request aborted");
        } else {
          alert("Error encountered - " + err.message);
        }

        controller.abort();
        return [];
      });
  } else {
    //const relatedFeatureSetByObjectId = await esriRequest(
    /*   operationalLayerUrl + "/queryRelatedRecords",
      {
        query: {
          f: "json",
          relationshipId: filteredOpLayer[0].AssessRelationShipId,
          objectIds: OIDArr.join(","), //pagination not supported
          outFields: "*",
          returnGeometry: "false",
        },
        responseType: "json",
      }
    );

    if (!relatedFeatureSetByObjectId) {
      return;
    } */
  }
};

export const displayTraceGraphics = (
  view: MapView,
  flag: Point,
  traceResults: any
) => {
  //console.log(traceResults);
  //   showLoading();
  try {
    if (
      traceResults != undefined &&
      traceResults != null &&
      traceResults != ""
    ) {
      if (traceResults.length > 0) {
        var geoms = traceResults.map((item: Graphic) => {
          return item.geometry;
        });
        geoms.push(flag); //add the flag
        var geom;
        var env = null;
        var gl = traceGraphicLayer;

        if (gl != null) {
          var flagGraphic = new Graphic({
            geometry: flag,
            symbol: {
              type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
              style: "x",
              color: "green",
              size: "10px", // pixels
              outline: {
                // autocasts as new SimpleLineSymbol()
                color: [0, 255, 0, 0.7],
                width: 6,
              },
            },
            attributes: null,
          });

          traceResults.forEach((item: Graphic) => {
            try {
              item.Geometry = item.geometry; // hack to zoom to features
              item.GeometryType = item.geometry.type; // hack to zoom to features
              if (JSON.stringify(item.geometry).indexOf("paths") > -1) {
                geom = new Polyline(item.geometry);
              } else {
                geom = new Point(item.geometry);
              }
              var symbol = getTraceSymbolForGeometry(geom);

              var graphic = new Graphic({
                geometry: geom,
                symbol: symbol,
                attributes: item.attributes,
              });
              gl.add(graphic);
              /* var ext = getShapeExt(view, geom);
              if (env === null) {
                env = ext;
              } else {
                env = env.union(ext);
              } */
            } catch (ex) {
              console.log(ex);
            }
          });
          //this._zoomToTrace();
          gl.add(flagGraphic);
          zoomToFeatures(view, traceResults);
        }
      }
    }
  } finally {
    // hideLoading();
    //clearTraceClickEvt();
  }
};
const getShapeExt = (view: MapView, geom: Geometry) => {
  if (geom.type == "point") {
    return new Extent({
      xmin: geom.x - 1,
      ymin: geom.y - 1,
      xmax: geom.x + 1,
      ymax: geom.y + 1,
      spatialReference: {
        wkid: geom.spatialReference.wkid,
      },
    });
  } else {
    return geom.extent;
  }
};

const getTraceSymbolForGeometry = (geom: Geometry) => {
  var symbol;
  var markerSymbol = {
    type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
    style: "circle",
    color: "blue",
    size: "20px", // pixels
    outline: {
      // autocasts as new SimpleLineSymbol()
      color: [255, 255, 0, 0.7],
      width: 12,
    },
  };
  var lineSymbol = {
    type: "simple-line", // autocasts as new SimpleLineSymbol()
    color: [255, 155, 0, 0.5],
    width: "12px",
    style: "solid",
    join: "round",
    miterLimit: "20px",
  };
  var polygonSymbol = {
    type: "simple-fill", // autocasts as new SimpleFillSymbol()
    color: [0, 255, 255, 0.5],
    style: "solid",
    outline: {
      // autocasts as new SimpleLineSymbol()
      color: [0, 255, 255, 0.7],
      width: 6,
      join: "round",
      miterLimit: "20px",
    },
  };
  switch (geom.type) {
    case "point":
      symbol = markerSymbol;
      break;
    case "polyline":
      symbol = lineSymbol;
      break;
    case "polygon":
      symbol = polygonSymbol;
      break;
  }
  return symbol;
};

export const closeOtherWidgetsOnLegendOpen = () => {
  let visiblePanels = Array.from(
    document.getElementsByClassName("esri-widget--panel slidein")
  );
  visiblePanels.forEach((item: any) => {
    item.classList.remove("slidein");
    item.classList.add("slideout");
  });
};
